// utils/jwt.ts
function base64UrlToString(input: string): string {
  // Base64URL -> Base64
  let b64 = input.replace(/-/g, '+').replace(/_/g, '/');
  // Padding ergänzen
  while (b64.length % 4) b64 += '=';
  // atob -> UTF-8
  const binary = atob(b64);
  const bytes = Uint8Array.from(binary, (c) => c.charCodeAt(0));
  return new TextDecoder().decode(bytes);
}

export function decodeJwt<T = Record<string, unknown>>(token: string): T {
  const [, payload] = token.split('.');
  if (!payload) throw new Error('Ungültiges JWT');
  const json = base64UrlToString(payload);
  return JSON.parse(json) as T;
}

export function getJwtExpiry(token: string): Date | null {
  const payload = decodeJwt<{ exp?: number }>(token);
  // exp ist in Sekunden seit Unix-Epoch
  return typeof payload.exp === 'number' ? new Date(payload.exp * 1000) : null;
}

export function getJwtTimeLeftMs(token: string): number | null {
  const exp = getJwtExpiry(token);
  if (!exp) return null;
  return exp.getTime() - Date.now();
}

export function isJwtExpired(token: string, leewaySeconds = 0): boolean {
  const left = getJwtTimeLeftMs(token);
  if (left === null) return false; // kein exp-Claim vorhanden
  return left <= -leewaySeconds * 1000;
}
